// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/credit_ledger_settings.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/credit_ledger_settings.proto.
 */
export const file_api_proto_v1_credit_ledger_settings: GenFile = /*@__PURE__*/
  fileDesc("CilhcGlfcHJvdG8vdjEvY3JlZGl0X2xlZGdlcl9zZXR0aW5ncy5wcm90bxIMYXBpX3Byb3RvLnYxIpQBChhDcmVkaXRMZWRnZXJTZXR0aW5nc0luZm8SGAoQZW5mb3JjZW1lbnRfbW9kZRgBIAEoCRIdChV1cGRhdGVkX2J5X2FkbWluX25hbWUYAiABKAkSDgoGcmVhc29uGAMgASgJEg8KB3VwZGF0ZWQYBCABKAkSHgoWdXBkYXRlZF9ieV9hZG1pbl9lbWFpbBgFIAEoCSIgCh5HZXRDcmVkaXRMZWRnZXJTZXR0aW5nc1JlcXVlc3QiWwofR2V0Q3JlZGl0TGVkZ2VyU2V0dGluZ3NSZXNwb25zZRI4CghzZXR0aW5ncxgBIAEoCzImLmFwaV9wcm90by52MS5DcmVkaXRMZWRnZXJTZXR0aW5nc0luZm8iTQohVXBkYXRlQ3JlZGl0TGVkZ2VyU2V0dGluZ3NSZXF1ZXN0EhgKEGVuZm9yY2VtZW50X21vZGUYASABKAkSDgoGcmVhc29uGAIgASgJIl4KIlVwZGF0ZUNyZWRpdExlZGdlclNldHRpbmdzUmVzcG9uc2USOAoIc2V0dGluZ3MYASABKAsyJi5hcGlfcHJvdG8udjEuQ3JlZGl0TGVkZ2VyU2V0dGluZ3NJbmZvQjNaMWdpdGh1Yi5jb20vaC1zY2FwZS9pZXNhcHVyaS9nby9hcGlfcHJvdG8vdjE7YXBpdjFiBnByb3RvMw");

/**
 * @generated from message api_proto.v1.CreditLedgerSettingsInfo
 */
export type CreditLedgerSettingsInfo = Message<"api_proto.v1.CreditLedgerSettingsInfo"> & {
  /**
   * 課金モード enforce / record
   *
   * @generated from field: string enforcement_mode = 1;
   */
  enforcementMode: string;

  /**
   * 最終変更した管理者の氏名。seed 起因（未変更）は空文字
   *
   * @generated from field: string updated_by_admin_name = 2;
   */
  updatedByAdminName: string;

  /**
   * 最新の変更理由。未変更は空文字
   *
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * 最終更新日時（RFC3339）
   *
   * @generated from field: string updated = 4;
   */
  updated: string;

  /**
   * 最終変更した管理者のメールアドレス。seed 起因（未変更）は空文字。
   * 氏名が未登録の Admin（development@ 等）でも更新者を特定できるよう、画面は監査ログと同じく
   * 「氏名が無ければメールアドレス」で表示する（approvalFormat.ts の formatAdminDisplayName）
   *
   * @generated from field: string updated_by_admin_email = 5;
   */
  updatedByAdminEmail: string;
};

/**
 * Describes the message api_proto.v1.CreditLedgerSettingsInfo.
 * Use `create(CreditLedgerSettingsInfoSchema)` to create a new message.
 */
export const CreditLedgerSettingsInfoSchema: GenMessage<CreditLedgerSettingsInfo> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_credit_ledger_settings, 0);

/**
 * @generated from message api_proto.v1.GetCreditLedgerSettingsRequest
 */
export type GetCreditLedgerSettingsRequest = Message<"api_proto.v1.GetCreditLedgerSettingsRequest"> & {
};

/**
 * Describes the message api_proto.v1.GetCreditLedgerSettingsRequest.
 * Use `create(GetCreditLedgerSettingsRequestSchema)` to create a new message.
 */
export const GetCreditLedgerSettingsRequestSchema: GenMessage<GetCreditLedgerSettingsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_credit_ledger_settings, 1);

/**
 * @generated from message api_proto.v1.GetCreditLedgerSettingsResponse
 */
export type GetCreditLedgerSettingsResponse = Message<"api_proto.v1.GetCreditLedgerSettingsResponse"> & {
  /**
   * @generated from field: api_proto.v1.CreditLedgerSettingsInfo settings = 1;
   */
  settings?: CreditLedgerSettingsInfo;
};

/**
 * Describes the message api_proto.v1.GetCreditLedgerSettingsResponse.
 * Use `create(GetCreditLedgerSettingsResponseSchema)` to create a new message.
 */
export const GetCreditLedgerSettingsResponseSchema: GenMessage<GetCreditLedgerSettingsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_credit_ledger_settings, 2);

/**
 * @generated from message api_proto.v1.UpdateCreditLedgerSettingsRequest
 */
export type UpdateCreditLedgerSettingsRequest = Message<"api_proto.v1.UpdateCreditLedgerSettingsRequest"> & {
  /**
   * 課金モード enforce / record
   *
   * @generated from field: string enforcement_mode = 1;
   */
  enforcementMode: string;

  /**
   * 変更理由（必須。admin_audit_logs にも記録する）
   *
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message api_proto.v1.UpdateCreditLedgerSettingsRequest.
 * Use `create(UpdateCreditLedgerSettingsRequestSchema)` to create a new message.
 */
export const UpdateCreditLedgerSettingsRequestSchema: GenMessage<UpdateCreditLedgerSettingsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_credit_ledger_settings, 3);

/**
 * @generated from message api_proto.v1.UpdateCreditLedgerSettingsResponse
 */
export type UpdateCreditLedgerSettingsResponse = Message<"api_proto.v1.UpdateCreditLedgerSettingsResponse"> & {
  /**
   * @generated from field: api_proto.v1.CreditLedgerSettingsInfo settings = 1;
   */
  settings?: CreditLedgerSettingsInfo;
};

/**
 * Describes the message api_proto.v1.UpdateCreditLedgerSettingsResponse.
 * Use `create(UpdateCreditLedgerSettingsResponseSchema)` to create a new message.
 */
export const UpdateCreditLedgerSettingsResponseSchema: GenMessage<UpdateCreditLedgerSettingsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_credit_ledger_settings, 4);

